var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.8291L5.25769 1.09222C5.28877 1.06311 5.32631 1.0399 5.36798 1.02404C5.40966 1.00818 5.45459 1 5.5 1C5.54541 1 5.59034 1.00818 5.63202 1.02404C5.67369 1.0399 5.71123 1.06311 5.74231 1.09222L10 4.8291",
    stroke: "#E63946",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8L5.25769 4.25703C5.3224 4.20128 5.40939 4.17004 5.5 4.17004C5.59061 4.17004 5.6776 4.20128 5.74231 4.25703L10 8",
    stroke: "#E63946",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.1a15894ee748b09aac5b3836bdc9e7e1.svg";
export { ForwardRef as ReactComponent };